import { t } from "i18next";
import { getMany, softDeleteById } from "services/holiday";
import { Util } from "common/util";
import withDataTable from "../withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";

const util = new Util();
const pathName = "/setting/public-holiday";
const columns = [
  {
    title: t("text_no"),
    dataIndex: "id",
    key: "id",
    width: 100,
    render: (id, record, index) => {
      const size = new URLSearchParams(document.location.search).get("size");
      const current = new URLSearchParams(document.location.search).get(
        "current"
      );
      let defaultCurrent = 1;
      let defaultPageSize = 10;

      if (current) {
        defaultCurrent = current;
      }

      if (size) {
        defaultPageSize = size;
      }
      return (defaultCurrent - 1) * defaultPageSize + (index + 1);
    },
  },
  {
    title: t("text_name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("text_nameKH"),
    dataIndex: "nameKH",
    key: "nameKH",
  },
  {
    title: t("text_start"),
    dataIndex: "start",
    key: "start",
    render: (start) => util.formatDate(start),
  },
  {
    title: t("text_end"),
    dataIndex: "end",
    key: "end",
    render: (end) => util.formatDate(end),
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 10;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_public_holidays"),
  showPagination: true,
  columns,
  defaultCurrent,
  defaultPageSize,
  pathName,
  getData,
  handleSearch,
  FormInsertOrUpdate,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});
